define([
	"dojo/_base/declare",
	"csi/def",
	"csi/heading/Ref",
	"csi/prefs"
], function(declare,def,Ref,prefs) {

	return declare(Ref, {
		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			// summary: return shared custom views for data sheet
			var	keyView = def.getPdfViewKey("SubRouting", null);
			h.m_relationship = prefs.getStoreRelationship(keyView);
			return this.inherited(arguments);
		}
	});
});